// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".project-option--ITL4c{min-width:12rem;gap:.5rem}.project-option-item--iS7Hg.dropdown-item.active{background-color:#f0f0f4}.project-option__icon--WGi7B{font-size:18px}.project-option__icon--none--a0M5v{color:#96a0b4;font-size:20px}.project-option__check--PjucD{margin-left:auto;color:#5645f5;font-size:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"project-option": "project-option--ITL4c",
	"project-option-item": "project-option-item--iS7Hg",
	"project-option__icon": "project-option__icon--WGi7B",
	"project-option__icon--none": "project-option__icon--none--a0M5v",
	"project-option__check": "project-option__check--PjucD"
};
export default ___CSS_LOADER_EXPORT___;
